module.exports = __webpack_public_path__ + "img/loin_glory.bae8a00c.png";